import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

import type { PinnedItemsState } from "./PinnedItemsState";

export interface PinnedItemsContextValue {
	state: PinnedItemsState;
}

const PinnedItemsContext = createContext<null | PinnedItemsContextValue>(null);

export const PinnedItemsContextProvider = PinnedItemsContext.Provider;

export const usePinnedItemsState = (): PinnedItemsState => {
	const { state } = useRequiredContext(PinnedItemsContext, {
		providerName: "PinnedItemsProvider",
	});

	return state;
};
